function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "wallet");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Telas-Incendio-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Emiss\\xE3o-Full-Page",
  transform: "translate(-333.000000, -2154.000000)",
  fill: "#FF6F0B",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "wallet",
  transform: "translate(333.000000, 2154.000000)"
}, React.createElement("path", {
  d: "M14,3.79930057 L1.5,3.79930057 L1.5,3.29093809 L12.5,2.39622014 L12.5,3.29093809 L14,3.29093809 L14,1.76585066 C14,0.647453217 13.109,-0.137458446 12.021,0.0201339213 L1.98,1.4781175 C0.891,1.6367266 0,2.68090312 0,3.79930057 L0,13.9665501 C0,15.0890144 0.895,16 2,16 L14,16 C15.104,16 16,15.0890144 16,13.9665501 L16,5.83275047 C16,4.71028613 15.104,3.79930057 14,3.79930057 Z M12.5,10.9224756 C11.672,10.9224756 11,10.2392364 11,9.39738816 C11,8.5555399 11.672,7.87230073 12.5,7.87230073 C13.328,7.87230073 14,8.5555399 14,9.39738816 C14,10.2392364 13.328,10.9224756 12.5,10.9224756 Z",
  id: "Shape"
}))));

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.5aef765a.svg";
export { ForwardRef as ReactComponent };